import { extractTextFromQuery } from '../../../utils/query';
import { user_firstName_$ilike_includes, user_lastName_$ilike_includes } from '../../../utils/query-helpers';

export default {
  param: extractTextFromQuery,
  query: function (text) {
    const words = text.trim().split(' ');

    if (text) {
      return {
        $or: words.map(function(word){
          return {
            ...user_firstName_$ilike_includes(word)
          };
        }).concat(words.map(function(word){
          return {
            ...user_lastName_$ilike_includes(word)
          };
        }))
      }
    }
  }
}
